import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { CognitoHostedUIIdentityProvider } from '@aws-amplify/auth';
import {
  AuthStoreService,
  DialogNgbService,
  MxLoggerService,
  Content,
  ContentDynamicLayout,
} from '@motivforce/mx-library-angular';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, skip, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@UntilDestroy()
@Component({
  selector: 'app-login-content-template',
  templateUrl: './login-content-template.component.html',
  styleUrls: ['./login-content-template.component.scss'],
})
export class LoginContentTemplateComponent implements OnInit, ContentDynamicLayout {
  @Input() baseContent: Content;

  mode: 'regular' | 'admin' = 'regular';
  background: string;

  formGroup: UntypedFormGroup = this.formBuilder.group({
    email: [null, [Validators.required]],
    password: [null, [Validators.required]],
  });

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private authStore: AuthStoreService,
    private dialogService: DialogNgbService,
    private mxLogger: MxLoggerService
  ) {}

  ngOnInit(): void {
    if (!this.router.url.includes('admin')) {
      this.mode = 'regular';
      const backgroundField = this.baseContent.fields.find((f) => f.name === 'Background');

      this.background = backgroundField!.value.url;
    } else {
      this.mode = 'admin';
      this.background = 'https://m9-cms-dev.s3.eu-west-2.amazonaws.com/public/lrau4lbkleap_login.jpg';
    }

    this.authStore.authenticatedUser$
      .pipe(untilDestroyed(this), skip(1), filter(Boolean))
      .subscribe((authenticatedUser) => {
        this.mxLogger.trace('LoginContainer', `mode ${this.mode} NEW authenticatedUser=`, authenticatedUser);
        this.router.navigate(['/home']);
      });
  }

  onSubmit(): void {
    if (this.formGroup.valid) {
      const formData = this.formGroup.getRawValue();

      this.authStore.signIn(formData.email, formData.password);
    } else {
      this.mxLogger.trace('LoginContainer', 'Form is still invalid.');
      this.dialogService.openError(['Please input a valid email address and password.'], 'Important');
    }
  }

  signInWithGoogle() {
    this.authStore.federatedSignIn(CognitoHostedUIIdentityProvider.Google);
  }

  signIn(): void {
    this.authStore.authenticatedUser$
      .pipe(untilDestroyed(this), filter(Boolean), take(1))
      .subscribe((authenticatedUser) => {
        this.mxLogger.debug('LoginContentTemplateComponent', 'signIn() authenticatedUser=', authenticatedUser);

        this.router.navigate(['/home']);
      });

    if (!this.authStore.authenticatedUser) {
      this.authStore.federatedSignIn(environment.oidc.provider);
    } else {
      this.router.navigate(['/home']);
    }
  }
}
